import { Fragment } from "react";

import WASC from "assets/img/common/wasc.png";
import AG from "assets/img/common/uc-ag-guide.png";

export const forSchools = {
  sectionTitle: {
    thinText: 'Accredited',
    regularText: 'Course',
  },
  sectionDesc: 'This course is nationally accredited and students may petition their school to receive high school transcript credit for taking this course.',
  buttonLink: "https://airtable.com/shrKuRrP6Kv1oNnNe",
  logos: [
    { src: WASC, alt: "WASC" },
    { src: AG, alt: "University Of California A-G Guide" },
  ],
  button: [
    {
      text: 'Interest Form',
      external: true,
      link: 'https://airtable.com/appdS9n7K25uof6m4/shrk9rCX4MuD6T0HY',
    },
  ],
};
